import { render, staticRenderFns } from "./TriggerPreview.vue?vue&type=template&id=38aaa370"
import script from "./TriggerPreview.vue?vue&type=script&lang=js"
export * from "./TriggerPreview.vue?vue&type=script&lang=js"
import style0 from "./TriggerPreview.vue?vue&type=style&index=0&id=38aaa370&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports